<template>
    <div class="newsDetail">
        <!-- 头部 -->
        <publicHeaders></publicHeaders>

        <!-- 主体 -->
        <div class="main">
            <div class="left">
                <div class="tab">
                    <span>您所在的位置：</span>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '/publicList', query: { documentTitle: cateName } }">{{ cateName }}</el-breadcrumb-item>
                      <el-breadcrumb-item>正文</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
                <div class="content">
                    <div class="top">
                        <div class="title">{{ detail.title }}</div>
                        <div class="info">
                            <span v-if="detail.source">{{ detail.source }}</span>
                            <div v-if="detail.source" class="interval"></div>
                            <span>http://www.qiyexinyong.org.cn</span>
                            <div class="interval"></div>
                            <span v-if="detail.publishTime">发布时间：{{ detail.publishTime.substring(0, 10) }}</span>
                        </div>
                    </div>
                    <div class="mainBody" v-loading="loading">
                        <!-- <img :src="baseUrl + detail.coverImg" alt=""> -->
                        <div class="article-rich-text" v-html="detail.content"></div>
                    </div>
                    <div class="attachment-panel" v-if="detail.fileList && detail.fileList.length">
                        <div class="attachment-title">附件下载</div>
                        <div class="attachment-list">
                            <a
                                v-for="(item, index) in detail.fileList"
                                :key="index"
                                class="attachment-link"
                                :href="item.url"
                                :download="item.name"
                                target="_blank"
                                rel="noopener"
                            >
                                <i class="el-icon-paperclip"></i>
                                <span class="attachment-name">{{ item.name }}</span>
                                <span class="attachment-action">点击下载</span>
                            </a>
                        </div>
                    </div>
                    <div class="bottom" style="margin-top: 15px;">
                        <div class="group" v-if="detail.source">
                            <img src="../assets/img/index/source.png" alt="">
                            <span>{{ detail.source }}</span>
                        </div>
                        <div class="group" style="margin-left: 30px;">
                            <img src="../assets/img/index/time.png" alt="">
                            <span v-if="detail.publishTime">{{ detail.publishTime.substring(0, 10) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <sideSearch></sideSearch>

                
                <!-- 相关新闻 -->
                <div class="correlation">
                    <div class="publicTop">
                        <div class="title">
                            <img src="../assets/img/index/correlation.png" alt="">
                            相关新闻
                        </div>
                        <!-- <div class="more">更多<i>》</i></div> -->
                    </div>
                    <div class="list">
                        <ul>
                            <li v-for="(item, index) in correlationList" :key="index" @click="toDetail(item, '新闻详情')">
                                <span>·</span>
                                <span class="title">{{ item.title }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- 底部 -->
        <div style="position: absolute;bottom: 0;left: 50%;transform: translateX(-50%);width: 100%;">
            <foot></foot>
        </div>
    </div>
</template>

<script>
import * as api from '../api/api'
import { decrypt } from '../utils/decode'
import publicHeaders from '../components/header.vue'
import foot from '../components/foot.vue'
import sideSearch from '../components/sideSearch.vue'
import {baseURL} from '../api/network.js';
export default {
    name: 'newsDetail',
    components: {
        publicHeaders,
        foot,
        sideSearch
    },
    data() {
        return {
            documentTitle: '',
            cateName: '',
            baseUrl: baseURL,
            searchValue: '',
            options: [
                {
                    value: '新闻中心',
                    label: '新闻中心'
                },
                {
                    value: '企业资讯',
                    label: '企业资讯'
                },
                {
                    value: '活动通知',
                    label: '活动通知'
                },
                {
                    value: '政策法规',
                    label: '政策法规'
                },
                {
                    value: '信用标准',
                    label: '信用标准'
                },
                {
                    value: '信用认证',
                    label: '信用认证'
                },
                {
                    value: '信用案例',
                    label: '信用案例'
                },
                {
                    value: '信用研究',
                    label: '信用研究'
                },
                {
                    value: '信用管理',
                    label: '信用管理'
                },
                {
                    value: '信用指数',
                    label: '信用指数'
                },
            ],
            searchSelect: '',
            detail: {
                // title: '海南：5年来制定30余项涉生态文明领域省级政策法规法制建设助力海南生态文明驶入快车道',
                // source: '企业信用建设服务平台',
                // web: 'http://www.ccbn.org.cn',
                // time: '2023/8/4',
                // updateTime: '2023-05-14',
                // content: '<div><img src="https://img1.jiemian.com/101/original/20180619/152941322442440200_a700xH.jpg" alt="" style="margin: 30px auto;"></div><p>8月1日，中国人民银行、国家外汇管理局召开2023年下半年工作会议。会议深入学习贯彻习近平新时代中国特色社会主义思想，落实党中央、国务院关于经济金融工作的决策部署，总结上半年工作，分析当前形势，部署下一阶段工作。中国人民银行党委书记、行长，国家外汇管理局党组书记、局长潘功胜出席会议并讲话。中国人民银行党委委员、国家外汇管理局党组成员出席会议。主题教育中央第三十三指导组副组长卢希到会指导。</p><p>会议认为，2023年以来，中国人民银行、国家外汇管理局认真贯彻党的二十大和中央经济工作会议精神，精准有力实施稳健的货币政策，有效防控金融风险，持续深化金融改革，切实改进金融服务，全面加强党的建设，各方面工作取得新成绩。</p><p>一是货币信贷和融资总量保持合理增长。保持流动性合理充裕，适时引导金融机构保持信贷总量适度、节奏平稳，实体经济融资成本稳中有降，金融支持实体经济力度保持稳固。</p><p>二是高质量发展重点领域和薄弱环节得到有效支持。调增支农支小再贷款、再贴现额度，延续实施普惠小微贷款支持工具、碳减排支持工具、支持煤炭清洁高效利用专项再贷款。指导金融机构用好设备更新改造专项再贷款。加强乡村振兴和农业强国建设金融服务。</p><p>三是外汇市场基本稳定。加强外汇市场“宏观审慎+微观监管”两位一体管理，优化企业汇率避险服务。人民币汇率在合理均衡水平上保持基本稳定。推动跨境贸易和投融资外汇便利化政策扩容提质。保障外汇储备资产安全、流动和保值增值。</p><p>四是重点领域金融风险得到有序处置。推动重点机构风险进一步化解。加快金融稳定保障基金积累。更好发挥存款保险功能。构建分级分段的银行风险监测、预警和硬约束早期纠正工作框架。延长“金融16条”有关政策适用期限，支持民营房企发行债券。加大保交楼金融支持力度。</p><p>五是金融改革开放深入推进。加强宏观审慎管理，完善系统性金融风险监测分析框架。组织开展国内系统重要性银行评估，落实附加监管要求。完善粤港澳大湾区“跨境理财通”业务试点。推动内地与香港利率“互换通”上线。</p><p>六是国际金融合作持续深化。积极开展重要金融外交，建设性参与二十国集团、国际货币基金组织等多边机制。推动建立国际清算银行人民币流动性安排。继续牵头做好二十国集团可持续金融工作。</p><p>七是金融服务与管理质效不断提升。加快推进金融法律体系建设。实施重要基础数据及资管产品等大数据统计。善始善终做好平台企业金融业务突出问题整改，加强常态化监管。深入开展金融领域关键信息基础设施安全保护工作。稳妥推进数字人民币研发。扎实推进国家金库工程建设。持续加强征信合规监管和金融消费者权益保护。加强高风险行业和机构反洗钱监管。有效发挥金融研究和参事建言献策作用。</p><p>会议指出，中国人民银行党委、国家外汇管理局党组坚持将政治建设摆在首位，全面从严治党向纵深推进。深入学习贯彻习近平总书记关于主题教育的重要指示批示精神，高标准高质量推进主题教育。扎实开展理论学习，大兴调查研究，深入开展干部队伍教育整顿。坚持以严的基调强化正风肃纪反腐。强化巡视和审计问题整改，全力配合经济责任审计。党校办学、工会和共青团工作、离退休干部服务、所属单位管理、集中采购、机关服务等工作质效持续提升。机构改革工作平稳推进。</p><p>会议要求，下半年，中国人民银行、国家外汇管理局系统要深刻领会中央关于经济形势的科学判断，进一步统一思想、坚定信心，切实抓好党中央、国务院决策部署贯彻落实，精准有力实施宏观调控，加强逆周期调节和政策储备，扎实推动经济高质量发展。</p><p>一是继续精准有力实施稳健的货币政策，持续改善和稳定市场预期，为实体经济稳定增长营造良好的货币金融环境。</p>',
            },
            loading: false,
            correlationList: [
                // {
                //     title: '2023年8月信用领域十大事件盘点'
                // },
                // {
                //     title: '9月涉及信用的新规'
                // },
                // {
                //     title: '个人信用报告到娜里查'
                // },
                // {
                //     title: '个人为什么要查询本人信用报告'
                // },
                // {
                //     title: '什么是个人信用记录'
                // },
                // {
                //     title: '信用评级机构最新情况公布'
                // },
                // {
                //     title: '信贷产品的成本结构解析'
                // },
                // {
                //     title: '国务院决定修改的行政法规，涉及信用内容及信用内容及信用内容'
                // },
            ]
        }
    },
    watch: {
      // 监听路由参数的变化
      '$route.query.id': {
        immediate: true,
        handler(newVal, oldVal) {
          // 当路由参数变化时，这里会被调用
          // 你可以在这里根据新的参数执行你的逻辑
        //   console.log('参数变化了:', newVal);
            this.documentTitle = this.$route.query.documentTitle
            document.title = this.$route.query.documentTitle
            this.getInfo(this.$route.query.id)
            this.getList()
        }
      }
    },
    created() {
        window.scrollTo(0 ,0)
        this.documentTitle = this.$route.query.documentTitle
        document.title = this.$route.query.documentTitle

        // this.getInfo(this.$route.query.id)
        // this.getList()
    },
    methods: {
        // 获取详情
        getInfo(id) {
            let _this = this
            _this.loading = true
            _this.detail = {}
            let params = {
                id: id,
            }
            api.getInfo(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    data.data.fileList = this.normalizeFileList(data.data)
                    _this.detail = data.data
                    _this.cateName = data.data.cate_name || data.data.cateName || _this.documentTitle.replace('详情', '')
                    _this.loading = false
                } else {
                    _this.loading = false
                }
            })
            .catch(error => {
                _this.loading = false
            //   _this.$toast('网络错误，请检查网络')
            })
        },
        normalizeFileList(detail) {
            const files = [
                ...this.parseLegacyFiles(detail.files),
                ...this.parseAttachFiles(detail.attachFile || detail.attach_file)
            ]
            const seen = {}
            return files.filter(item => {
                if (!item.url || seen[item.url]) return false
                seen[item.url] = true
                return true
            })
        },
        parseLegacyFiles(files) {
            if (files === '' || files === null || files === undefined || files === '-') return []
            // 先尝试整体 JSON 解析，避免先 split(',') 把 JSON 字符串拆坏
            if (!Array.isArray(files)) {
                const raw = String(files).trim()
                if (!raw) return []
                try {
                    const parsed = JSON.parse(raw)
                    if (Array.isArray(parsed)) {
                        return parsed.map(item => this.buildFileItem(item)).filter(Boolean)
                    }
                    const item = this.buildFileItem(parsed)
                    if (item) return [item]
                    // 解析出来不是有效附件，继续走旧格式
                } catch (_) { /* 不是 JSON，走旧格式 */ }
            }
            // 旧格式："文件名-/upload/xxx" 或 "文件名-/zqy/static/upload/xxx" 或 "文件名-http://..."
            const source = Array.isArray(files) ? files : String(files).split(',')
            return source.map(item => {
                const text = String(item).trim()
                if (!text) return null
                // 再试一次单项 JSON（兼容旧格式 split 后恰好没拆坏的情况）
                try {
                    const obj = JSON.parse(text)
                    const item = this.buildFileItem(obj)
                    if (item) return item
                } catch (_) { /* 不是 JSON，走旧逻辑 */ }
                // 纯 URL/路径 以这些前缀开头，直接取文件名，避免 patterns 匹配时 idx===0 掉到
                // lastIndexOf('-') 兜底把 URL 拆坏（如 https://example.com/2026-credit-report.pdf）
                const purePrefixes = ['/zqy/static/upload', '/static/upload', 'http://', 'https://']
                if (purePrefixes.some(p => text.startsWith(p))) {
                    return {
                        name: this.getFileName(text),
                        url: this.resolveFileUrl(text)
                    }
                }
                // 按 URL 特征拆分，而不是第一个 '-'，避免文件名含横杠时拆错
                const patterns = ['/zqy/static/upload', '/static/upload', 'http://', 'https://']
                let splitIdx = -1
                for (const p of patterns) {
                    const idx = text.indexOf(p)
                    if (idx > 0) { splitIdx = idx; break }
                }
                let name, url
                if (splitIdx > 0) {
                    name = text.slice(0, splitIdx).replace(/-$/, '').trim()
                    url = text.slice(splitIdx)
                } else {
                    // 兜底：用最后一个 '-' 拆分
                    const lastDash = text.lastIndexOf('-')
                    if (lastDash > 0) {
                        name = text.slice(0, lastDash)
                        url = text.slice(lastDash + 1)
                    } else {
                        name = this.getFileName(text)
                        url = text
                    }
                }
                if (!url) return null
                return {
                    name: name || this.getFileName(url),
                    url: this.resolveFileUrl(url)
                }
            }).filter(Boolean)
        },
        buildFileItem(raw) {
            if (!raw) return null
            if (typeof raw === 'string') {
                return {
                    name: this.getFileName(raw),
                    url: this.resolveFileUrl(raw)
                }
            }
            const url = raw.url || raw.fileSrc || raw.path || ''
            const name = raw.name || raw.fileName || this.getFileName(url)
            if (!url) return null
            return {
                name: name || '附件',
                url: this.resolveFileUrl(url)
            }
        },
        parseAttachFiles(files) {
            if (files === '' || files === null || files === undefined || files === '-') return []
            let source = files
            if (typeof files === 'string') {
                const value = files.trim()
                if (!value) return []
                try {
                    source = JSON.parse(value)
                } catch (err) {
                    source = value.split(',')
                }
            }
            if (!Array.isArray(source)) source = [source]
            return source.map(item => {
                const url = typeof item === 'string' ? item : (item.url || item.fileSrc || item.path || '')
                const name = typeof item === 'string' ? this.getFileName(item) : (item.name || item.fileName || this.getFileName(url))
                if (!url) return null
                return {
                    name: name || '附件',
                    url: this.resolveFileUrl(url)
                }
            }).filter(Boolean)
        },
        resolveFileUrl(url) {
            const value = String(url || '').trim()
            if (!value) return ''
            if (/^(https?:)?\/\//.test(value) || value.indexOf('data:') === 0) return value
            let base = String(this.baseUrl || '').replace(/\/$/, '')
            if (value.startsWith('/zqy/')) {
                base = base.replace(/\/zqy\/?$/, '')
            }
            const path = value.replace(/^\//, '')
            return base + '/' + path
        },
        getFileName(url) {
            const pureUrl = String(url || '').split('?')[0].split('#')[0]
            const name = pureUrl.split('/').pop() || '附件'
            try {
                return decodeURIComponent(name)
            } catch (err) {
                return name
            }
        },

        // 获取相关新闻
        getList() {
            let _this = this
            let params = {
                cateId: 1,
                title: '',
                page: 1,
                size: 10,
            }
            api.getList(params).then(res => {
                let { data } = res
                console.log(data);
                if (data.status == 200) {
                    _this.correlationList = data.data.data
                } else {
                }
            })
            .catch(error => {
            //   _this.$toast('网络错误，请检查网络')
            })
        },

        // 前往详情
        toDetail(item, title) {
            this.$router.push({
                name: 'newsDetail',
                query: {
                    documentTitle: title,
                    id: item.id
                }
            })
            // let routeUrl = this.$router.resolve({
            //   path: "/newsDetail"
            // });
            // // console.log(routeUrl);
            // window.open(routeUrl.href+ '?documentTitle=' + title + '&id=' + item.id, '_blank');
        },

    }
}
</script>

<style lang="less" scoped>
.newsDetail {
    position: relative;
    padding-bottom: 140px;
    .main {
        width: 1200px; /*no*/
        padding: 15px 0;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        @media only screen and (min-width: 769px) {
            min-width: 1200px; /*no*/
        }
        .left {
            flex: 1;
            min-width: 0;
            margin-right: 24px;
            .tab {
                background-color: #F2F2F2;
                display: flex;
                align-items: center;
                font-size: 16px;
                padding: 5px 10px;
            }
            .content {
                min-height: 500px;
                border: 1px solid #D9D9D9;
                margin-top: 10px;
                padding: 20px;
                .top {
                    padding: 5px 0 20px;
                    border-bottom: 1px solid #DCDCDC;
                    .title {
                        font-size: 30px;
                        /* color: #666; */
                    }
                    .info {
                        margin-top: 15px;
                        display: flex;
                        justify-content: left;
                        align-items: center;
                        color: #666;
                        font-size: 16px;
                    }
                    .interval {
                        width: 1px;
                        height: 20px;
                        background-color: #666;
                        margin: 0 25px;
                    }
                }
                /deep/ .mainBody {
                    font-size: 22px !important;
                    line-height: 27px;
                    color: #666;
                    padding: 20px 0;
                    .article-rich-text {
                        max-width: clamp(820px, 62vw, 960px); /*no*/
                        margin: 0 auto;
                    }
                    img {
                        margin: 0 auto;
                        max-width: 100%;
                        /* padding-bottom: 20px; */
                    }
                    p {
                        margin: 0 0 0.5em 0;
                        line-height: 1.8;
                    }
                    * {
                        font-family: 'Source Han Sans CN' !important;
                        color: #333 !important;
                        line-height: 32px !important;
                        font-size: 20px; 
                    }
                    a,
                    a * {
                        color: #1A68E8 !important;
                    }
                    a {
                        text-decoration: underline !important;
                        text-underline-offset: 4px;
                        font-weight: 600;
                        cursor: pointer;
                    }
                    a:hover {
                        color: #0F4FB8 !important;
                    }
                }
                .attachment-panel {
                    margin: 8px 0 22px;
                    padding: 16px 18px;
                    border: 1px solid #BFD8FF;
                    border-radius: 4px;
                    background: #F5FAFF;
                    .attachment-title {
                        color: #1A68E8;
                        font-size: 18px;
                        font-weight: 700;
                        line-height: 24px;
                    }
                    .attachment-list {
                        margin-top: 8px;
                    }
                    .attachment-link {
                        display: flex;
                        align-items: center;
                        width: 100%;
                        min-height: 34px;
                        color: #1A68E8;
                        font-size: 18px;
                        line-height: 28px;
                        text-decoration: underline;
                        text-underline-offset: 4px;
                        cursor: pointer;
                        i {
                            margin-right: 8px;
                            font-size: 18px;
                        }
                        .attachment-name {
                            flex: 1;
                            min-width: 0;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .attachment-action {
                            margin-left: 14px;
                            color: #0F4FB8;
                            font-size: 16px;
                            font-weight: 600;
                            white-space: nowrap;
                        }
                    }
                    .attachment-link + .attachment-link {
                        margin-top: 6px;
                    }
                    .attachment-link:hover {
                        color: #0F4FB8;
                    }
                }
                .bottom {
                    display: flex;
                    justify-content: right;
                    align-items: center;
                    .file {
                        a:hover {
                            color: #258AFF;
                        }
                    }
                    .group {
                        display: flex;
                        align-items: center;
                        font-size: 18px;
                        color: #666;
                        img {
                            width: 16px;
                            height: 16px;
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
        .right {
            flex: 0 0 330px; /*no*/
            width: 330px; /*no*/
            margin-left: 0;
            .correlation {
                margin-top: 10px;
                .publicTop {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 10px;
                    border: 1px solid #85B2FF;
                    background: linear-gradient(to bottom, #EAF6FF, #ECF7FF, #DEF0FF, #E9F5FF, #F6FBFF);
                    .title {
                        color: #1A68E8;
                        font-size: 18px;
                        display: flex;
                        align-items: center;
                        img {
                            margin-right: 5px;
                        }
                    }
                    .more {
                        font-size: 14px;
                        color: #999;
                        cursor: pointer;
                    }
                }
                .list {
                    border: 1px solid #D9D9D9;
                    border-top: none;
                    padding: 15px;
                    li {
                        font-size: 18px;
                        color: #666;
                        display: flex;
                        justify-content: left;
                        cursor: pointer;
                        .title {
                            margin-left: 5px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            width: 100%;
                        }
                    }
                    li:nth-of-type(n+2) {
                        margin-top: 5px;
                    }
                    li:hover {
                        color: #258AFF;
                    }
                }
            }
        }
    }
}
</style>
